export default __webpack_public_path__ + "static/media/baby-boy.f5b91235.png";